import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem('token') || ''}` });

export default function StudentGrAddCode(){
    const nav = useNavigate();
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState('');
    const [ok, setOk] = useState('');

    async function submit(e){
        e.preventDefault();
        setErr(''); setOk('');
        const val = (code || '').trim().toUpperCase();
        if (!val) { setErr('Podaj kod'); return; }

        setLoading(true);
        try{
            // Backend powinien zwrócić { ok:true, group_id, group_name } jeśli się uda
            const r = await fetch('/api/student/grupy/join-code', {
                method:'POST',
                credentials:'include',
                headers:{ 'Content-Type':'application/json', ...authHeader() },
                body: JSON.stringify({ code: val })
            });
            const j = await r.json().catch(()=> ({}));
            if (!r.ok || !j?.ok) throw new Error(j?.blad || `Nie udało się dołączyć (HTTP ${r.status})`);

            setOk(`Dołączono do grupy: ${j.group_name || j.group_id}`);
            // po chwili przejście do grupy
            setTimeout(()=> nav(`/student/grupa/${j.group_id}`), 800);
        }catch(e){
            setErr(e.message || 'Nie udało się dołączyć');
        }finally{
            setLoading(false);
        }
    }

    return (
        <div style={{ maxWidth: 560, padding:'0 16px', marginTop:80 }}>
            <h1>Dołącz do grupy</h1>
            <form onSubmit={submit} style={{ border:'1px solid #e5e7eb', borderRadius:12, padding:16, background:'#fff', display:'grid', gap:12 }}>
                <label style={{ display:'grid', gap:6 }}>
                    <span style={{ color:'#6b7280', fontSize:13 }}>Wpisz kod grupy</span>
                    <input
                        value={code}
                        onChange={e=>setCode(e.target.value)}
                        placeholder="np. GZ5H12K9"
                        style={{ padding:'8px', border:'1px solid #e5e7eb', borderRadius:8, textTransform:'uppercase' }}
                    />
                </label>
                <div style={{ display:'flex', gap:8 }}>
                    <button  className={'but-smal'} type="submit" disabled={loading} style={{ padding:'8px 12px' }}>
                        {loading ? 'Dodawanie…' : 'Dołącz'}
                    </button>
                    <button type="button" onClick={()=>nav('/student/grupy')} style={{ border:'1px solid #e5e7eb', background:'#fff', borderRadius:8, padding:'8px 12px' }}>
                        Anuluj
                    </button>
                </div>
                {ok && <div style={{ color:'#166534' }}>{ok}</div>}
                {err && <div style={{ color:'#b91c1c' }}>{err}</div>}
            </form>
            <div style={{ marginTop:12, color:'#6b7280', fontSize:13 }}>
                Kod zawiera maksymalnie 8 cyfr i/lub wielkich liter.
            </div>
        </div>
    );
}
